import React, { FC, useCallback } from "react";
import { useDispatch } from "react-redux";
import FavouriteVariant from "./FavouriteVariant";
import {
  useFavouriteIds,
  useIsFavouriteFetching,
} from "../../../../../store/favouriteTemplates/hooks/useSelectors";
import useTemplateDataFromIds from "./useTemplateDataFromIds";
import { changeOrder } from "../../../../../store/favouriteTemplates/thunks";

const Container: FC<Props> = ({ onClickSideEffects }) => {
  const favouriteIds = useFavouriteIds();
  const isFetching = useIsFavouriteFetching();

  const templateData = useTemplateDataFromIds(favouriteIds);

  const dispatch = useDispatch();

  const changeOrderOfFavourite = useCallback(
    (id: number, order: number) => {
      dispatch(changeOrder(id, order));
    },
    [dispatch]
  );

  const isLoading = isFetching && templateData.length === 0;

  return (
    <FavouriteVariant
      isLoading={isLoading}
      loaderConfig={{ size: 50 }}
      templateData={templateData}
      changeOrderOfFavourite={changeOrderOfFavourite}
      toggleModal={onClickSideEffects}
    />
  );
};

export type Props = { onClickSideEffects?: () => void };

export default Container;
export type ContainerProps = Props;
